import { Tooltip } from "@digital-services/ui";

import { EntityType, Relationship, RelationshipType } from "@resource/models";

import { CustomTooltipForOwner } from "./CustomTooltipForOwner";

interface CellContentProps {
  relationships: Relationship[];
}

export const OwnerCellContentWithTooltip = (props: CellContentProps) => {
  const { relationships } = props;

  const reallyJustOwners = relationships?.filter(
    ({ entityType, relationshipType }) =>
      entityType === EntityType.Organization &&
      relationshipType === RelationshipType.Owner
  );

  const justOwnerNames: string[] = reallyJustOwners?.map(e => {
    return e.entityName!;
  });

  const stringToVerify = justOwnerNames?.join("; ");

  const msg =
    stringToVerify.length > 30 && justOwnerNames?.length > 0 ? (
      <CustomTooltipForOwner items={reallyJustOwners} />
    ) : null;

  let ownerValueForCell =
    justOwnerNames?.length > 0 ? `${justOwnerNames[0]}` : "";

  if (justOwnerNames?.length === 2) {
    ownerValueForCell = `${justOwnerNames[0]}; ${justOwnerNames[1]}`;
  } else if (justOwnerNames?.length >= 2) {
    ownerValueForCell = `${justOwnerNames[0]}; ${justOwnerNames[1]} ...`;
  }

  return (
    <Tooltip message={msg}>
      <div className="truncate text-ellipsis">{ownerValueForCell}</div>
    </Tooltip>
  );
};
